"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM6 14l1-5H4l6-7-1 5h3l-6 7z"];
//# sourceMappingURL=offline.js.map